export default __webpack_public_path__ + "static/media/TTP_Broken Promises_dataset.b2e3987d.xlsx";